
// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';

import { initializeApp } from 'firebase/app';
//import firebase from "firebase";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/auth";
import "firebase/compat/firestore"
import "firebase/compat/messaging"
import "firebase/compat/app-check"
//import "firebase/compat/messaging"

// BIZh6GbsBICTrsS3iIg-3ULPxdxeiANVsJqg4jN099neXc5T-jnLGWGDotzr_ojp99vqI8pCFJgrbuX6n8NFx7I

const config = {
  apiKey: "AIzaSyABmBW6EsaQ-lQmXuUc2lgciq5Id7A1G-w",
  authDomain: "boomdisplays-3e87d.firebaseapp.com",
  databaseURL: "https://boomdisplays-3e87d-default-rtdb.firebaseio.com",
  projectId: "boomdisplays-3e87d",
  storageBucket: "boomdisplays-3e87d.appspot.com",
  messagingSenderId: "166729557567",
  appId: "1:166729557567:web:25128a47ec66b540d77a8a",
  measurementId: "G-6BCDDG6D5H"
};

firebase.initializeApp(config);
//const messaging = getMessaging(firebaseApp);
// const db=firebase.database();

export const db = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
//export const messaging = firebase.messaging();

/*
export const fetchToken = async (setTokenFound) => {
  const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
  await navigator.serviceWorker.ready;
  return getToken(messaging, { vapidKey: 'BIZh6GbsBICTrsS3iIg-3ULPxdxeiANVsJqg4jN099neXc5T-jnLGWGDotzr_ojp99vqI8pCFJgrbuX6n8NFx7I',serviceWorkerRegistration: reg  }).then((currentToken) => {
    if (currentToken) {
      console.log('current token for client: ', currentToken);
      setTokenFound(currentToken);
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      console.log('No registration token available. Request permission to generate one.');
      setTokenFound(false);
      // shows on the UI that permission is required 
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
    // catch error while creating client token
  });
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
  */
//export const auth = firebase.auth();
//export const firestore = firebase.firestore()
//export const firebases = firebase;